import PublicLayout from "@/components/PublicLayout";
import HallOfFameGallery from "@/components/HallOfFameGallery";

export default function HallOfFame() {
  return <PublicLayout>
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl text-white font-semibold text-center">Hall da Fama <span className="gold-text">GSX</span></h1>
      <p className="text-slate-400 text-center mt-3 mb-10">Títulos e conquistas dos atletas do Grupo Santo de Xadrez.</p>
      <HallOfFameGallery />
    </section>
  </PublicLayout>;
}
